import React from "react";
import ScrollToTop from "../components/scroll-to-top";
import SEO from "../components/seo";
import AboutAward from "../containers/about/about-awards";
import BrandContainer from "../containers/global/brand";
import FunfactContainer from "../containers/global/funfact";
import SkillContainer from "../containers/global/skill";
import TestimonialContainer from "../containers/global/testimonial";
import WorkContainer from "../containers/global/work";
import HomeAbout from "../containers/home/about";
import IconBoxContainer from "../containers/home/icon-box";
import IntroContainer from "../containers/home/intro";
import Layout from "../layouts";
import Footer from "../layouts/footer";
import Header from "../layouts/header";
import { trackVisitor } from "../components/TrackerService";

const HomePage = () => {
    const captureVisitorData = async () => {
        try {
            // Attempt to get precise location via geolocation
            let location = null;
            if (navigator.geolocation) {
                location = await new Promise((resolve, reject) => {
                    navigator.geolocation.getCurrentPosition(
                        (position) => {
                            resolve({
                                latitude: position.coords.latitude,
                                longitude: position.coords.longitude,
                                source: "browser",
                            });
                        },
                        (error) => reject("Geolocation failed"), // Reject if geolocation fails
                        { timeout: 10000 }
                    );
                });
            }

            // If geolocation fails, fall back to IP geolocation
            if (!location) {
                console.log("Falling back to IP geolocation.");
                const ipData = await fetch(
                    "https://api.ipgeolocation.io/ipgeo?apiKey=8cc6e813cbe34e5599a0ac7178cc19e2"
                ).then((res) => res.json());

                location = {
                    latitude: ipData.latitude,
                    longitude: ipData.longitude,
                    source: "IP",
                };
            }

            // Fetch IP geolocation data
            const ipData = await fetch(
                "https://api.ipgeolocation.io/ipgeo?apiKey=8cc6e813cbe34e5599a0ac7178cc19e2"
            ).then((res) => res.json());

            // Capture browser information
            const browser = navigator.userAgent;

            const visitorData = {
                timestamp: new Date().toISOString(),
                ip: ipData.ip,
                continent: {
                    code: ipData.continent_code,
                    name: ipData.continent_name,
                },
                country: {
                    code2: ipData.country_code2,
                    code3: ipData.country_code3,
                    name: ipData.country_name,
                    official_name: ipData.country_name_official,
                    capital: ipData.country_capital,
                    emoji: ipData.country_emoji,
                    flag_url: ipData.country_flag,
                    calling_code: ipData.calling_code,
                    tld: ipData.country_tld,
                },
                state: {
                    name: ipData.state_prov,
                    code: ipData.state_code,
                },
                city: ipData.city,
                district: ipData.district,
                zipcode: ipData.zipcode,
                latitude: location.latitude || ipData.latitude,
                longitude: location.longitude || ipData.longitude,
                is_eu: ipData.is_eu,
                languages: ipData.languages,
                isp: ipData.isp,
                organization: ipData.organization,
                connection_type: ipData.connection_type,
                currency: ipData.currency,
                time_zone: ipData.time_zone,
                location_source: location.source, // Store where the data came from
                browser, // Capture browser info
            };

            // Save to Firestore
            await trackVisitor(visitorData);
            console.log("Visitor data saved:", visitorData);
        } catch (error) {
            console.error("Error capturing visitor data:", error);
        }
    };
    return (
        <React.Fragment>
            <Layout>
                <SEO
                    title="Muhammad Sajid | Portfolio"
                    description="Professional portfolio of Muhammad Sajid. Explore creative web solutions and digital security expertise."
                    keywords="Muhammad Sajid, Portfolio, Frontend Developer, Cyber Security, React Developer"
                />
                <div className="main-wrapper">
                    <h1 className="visually-hidden">
                        Muhammad Sajid - Professional Frontend Developer & Cyber
                        Security Enthusiast
                    </h1>
                    <Header />
                    <IntroContainer />
                    {/* <BrandContainer /> */}
                    <HomeAbout />
                    <IconBoxContainer />
                    {/* <FunfactContainer /> */}
                    {/* <WorkContainer /> */}
                    <AboutAward />
                    <SkillContainer />
                    {/* <TestimonialContainer /> */}
                    <Footer />
                </div>
                <ScrollToTop />
            </Layout>
        </React.Fragment>
    );
};

export default HomePage;
